<template>
    <div class="collection border-bottom-light-gray js-navigatable" :id="'type-pack-' + index" :data-name="productType.name">
        <div class="collection__inner pb-3 pb-md-6 pt-md-8" :id="'type-'+productType.id">
            <div class="konfiguratorItem">

                <confirm-delete-popup
                    @confirm="submitDeleteFilligs"
                    @cancel="closeConfirmDeletePopup"
                    :show="showConfirmPopup"
                    inBasket
                    :message="$t('components.ConfirmDeletePopup.title')"
                ></confirm-delete-popup>

                <div class="konfiguratorItem__imagesWrap"></div>
                <div class="konfiguratorItem__content" :class="{'loading' : loadingNew}">

                    <div class="pb-1">
                        <div class="row align-items-end">
                            <div class="col-md-8 pr-0">
                                <div class="title">{{ typeHeaderText }}</div>
                            </div>

                            <div class="col-md-4 text-right" v-if="renderMeasurePopup">
                                    <!--
                                        <a href="#"  @click.prevent="showHowToMeasurePopup = true" class="link-underline link-underline--gray">{{ howToMeasureText }}</a>
                                    -->
                            </div>
                            <div class="col-md-7">
                                <p class="description mt-3" v-html="productType.description">
                                </p>
                            </div>
                        </div>
                    </div>

                    <product-select
                        :key="prod.uid"
                        :product="prod"
                        v-for="(prod, index) in products"
                        :type-code="productType.code"
                        :group-code="productType.groupCode"
                    >
                    </product-select>

                    <div class="konfiguratorRow konfiguratorRow--addnew py-3 py-md-2 mb-md-7">
                        <span class="tooltip w-100 w-md-auto" :class="{'js-tooltip' : isDisabledAdd}">
                            <span class="js-tooltip-trigger d-inline-block w-100 w-md-auto">
                                <div class="tooltip__window">{{ $t('components.TypePack.disabledAdd') }}</div>
                                <button
                                    @click.prevent="addRow"
                                    class="btn btn--small btn--white w-100 w-md-auto"
                                    :disabled="isDisabledAdd"
                                >
                                    <span class="order-md-2">{{ addText }}</span>
                                    <svg class="ml-auto ml-md-0 ico ico--regular">
                                        <use xlink:href="#add"/>
                                    </svg>
                                </button>
                            </span>
                        </span>
                        <div class="mt-3 d-none" v-if="hasFill">
                            <span class="js-tooltip tooltip" data-tooltip-hide="2000">
                                <span class="js-tooltip-trigger d-inline-block">
                                    <div class="tooltip__window" v-if="!isDisabledFilling">
                                        <img :src="fillingTooltipImgSrc"
                                            alt=""
                                            style="max-width: 200px; max-height: 200px;">
                                    </div>
                                    <label class="custom-formField mb-0" v-if="false">
                                        <input
                                            type="checkbox"
                                            v-model="showFillings"
                                            @change="showFillingChange"
                                            :disabled="isDisabledFilling"
                                        />
                                        <span class="text-uppercase">{{ wantFillingText }} - <strong
                                            class="text-highlight">{{
                                                $t('components.TypePack.oursTip')
                                            }}</strong></span>
                                    </label>
                                </span>
                            </span>
                        </div>
                    </div>

                    <div v-if="displayFillings">
                        <product-select
                            :key="index"
                            :product="prod"

                            :fixed="true"
                            v-for="(prod, index) in displayableFillingProducts">
                        </product-select>

                    </div>

                </div>
            </div>
        </div>
    </div>
</template>

<script>
import ProductSelect from "./ProductSelect";
import ConfirmDeletePopup from "@/components/ConfirmDeletePopup";

export default {
        components: {ConfirmDeletePopup, ProductSelect},
        props: ["productType", "index", "total"],
        data: function () {
            return {
                showFillings: false,
                showHowToMeasurePopup: false,
                showConfirmPopup: false,
                loadingNew: false,
            }
        },
        computed: {
            products: function () {
                return this.$store.getters.itemsByType(this.productType.id);
            },
            hasColorParameter: function () {
                var parametes = this.$store.getters.getTechnicalParameters(this.productType.id);
                var colorParametes = parametes.filter(function (tp) {
                    return [
                        1073, // Barva osušky
                        1071, // Barva ručníku
                        1082 // Barva županu
                    ].includes(tp.id);
                });
                return colorParametes.length > 0;
            },
            hasFill: function () {
                return (this.code === 'duvet' || this.code === 'pillow') && this.productType.groupCode !== 'filling' ;
            },
            code: function () {
                return this.productType.code;
            },
            displayFillings: function () {
                return this.showFillings;
            },
            productCount: function() {
                return this.products.length;
            },
            renderMeasurePopup: function () {
                let renderMeasurePopup = false;
                if (this.productType.groupCode === 'cover') {
                    renderMeasurePopup = ['duvet', 'pillow'].includes(this.productType.code)
                } else {
                    renderMeasurePopup = ['bathrobe', 'sheet'].includes(this.productType.code)
                }
                return renderMeasurePopup;
            },
            isDisabledAdd: function () {
                return this.products.some(function(product) {
                    return !product.inBasket;
                });
            },
            isDisabledFilling: function () {
                return !this.products.some(function(product) {
                    return product.inBasket;
                });
            },
            fillingTooltipImgSrc: function() {
                return '/images/foto/collections/' + (this.code === 'pillow' ? '32/1.jpg' : '33/1.jpg')
            },
            addText: function () {
                return this.$t('components.TypePack.addButton.' + this.productType.groupCode + '.' + this.productType.code);
            },
            typeHeaderText: function () {
                return this.productType.name;
            },
            howToMeasureText: function () {
                return this.$t('components.TypePack.howToMeasure.' + this.productType.groupCode + '.' + this.productType.code);
            },
            wantFillingText: function () {
                if (this.code === 'pillow') {
                    return this.$t('components.TypePack.wantFillingPillow');
                } else {
                    return this.$t('components.TypePack.wantFillingDuvet');
                }
            },
            addFillingText: function () {
                if (this.code === 'pillow') {
                    return this.$t('components.TypePack.addPillow');
                } else {
                    return this.$t('components.TypePack.addDuvet');
                }
            },
            fillingTypeText: function () {
                if (this.code === 'pillow') {
                    return this.$t('components.TypePack.fillingTypePillow');
                } else {
                    return this.$t('components.TypePack.fillingTypeDuvet');
                }
            },
            fillingProducts: function () {
                return this.$store.getters.fillingItems(this.productType.id);
            },
            displayableFillingProducts: function () {
                if (!this.displayFillings) {
                    return [];
                }
                return this.fillingProducts;
            }
        },
        created() {
            if (this.fillingProducts.length > 0) {
                this.showFillings = true;
            }
        },
        methods: {
            addRow: function () {
                this.$store.dispatch("addItem", this.productType.id).finally(function() {
                    $(document).trigger('configuratorUpdated');
                });
            },
            addFillingRow: function () {
                this.$store.dispatch("addFillingItem", this.productType.id);
            },
            showFillingChange: function () {
                if(!this.showFillings && this.fillingProducts.some(function(product) {return product.inBasket;})) {
                    this.showConfirmPopup = true;
                } else {
                    this.$store.dispatch('changeAutomaticFilling', {productTypeId: this.productType.id, value: this.showFillings})
                }
            },
            submitDeleteFilligs: function() {
                this.showConfirmPopup = false;
                this.$store.dispatch('changeAutomaticFilling', {productTypeId: this.productType.id, value: false})
                .then(function() {
                    $('#basket-update').trigger('click');
                })
            },
            closeConfirmDeletePopup: function() {
                this.showConfirmPopup = false;
                this.showFillings = true;
            },
            prefill: function () {
                this.$store.dispatch("prefillItems", this.productType.id);
            },
        },
        watch: {
            productCount: function (newVal) {
                var vm = this;

                if (newVal > 0) {
                    return;
                }

                this.loadingNew = true;

                if (this.showFillings) {
                    this.showFillings = false;
                    this.$store.dispatch('changeAutomaticFilling', {
                        productTypeId: this.productType.id,
                        value: this.showFillings
                    })
                        .then(function () {
                            return vm.$store.dispatch("addItem", vm.productType.id)
                        })
                        .finally(function () {
                            vm.loadingNew = false;
                            $(document).trigger('configuratorUpdated');
                        });
                } else {
                    this.$store.dispatch("addItem", vm.productType.id)
                        .finally(function () {
                            vm.loadingNew = false;
                            $(document).trigger('configuratorUpdated');
                        })
                }

            }
        }
    };
</script>
